/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ad_Backup_Llm_LabelInputs */



/**
* | output |
* | --- |
* | "Backup AI Model (optional)" |
*
* @param {Ad_Backup_Llm_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ad_backup_llm_label = /** @type {((inputs?: Ad_Backup_Llm_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ad_Backup_Llm_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Modèle d'IA de sauvegarde (facultatif)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Backup-KI-Modell (optional)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Modello di intelligenza artificiale di backup (opzionale)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Резервная модель ИИ (опционально)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Modelo de IA de respaldo (opcional)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("备用AI模型（可选）")
	if (locale === "ja") return /** @type {LocalizedString} */ ("バックアップAIモデル（オプション）")
	if (locale === "hi") return /** @type {LocalizedString} */ ("बैकअप एआई मॉडल (वैकल्पिक)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Modelo de IA de backup (opcional)")
	return /** @type {LocalizedString} */ ("Backup AI Model (optional)")
});